export const generateDocumentFields = (appointmentType: string) => {
  switch (appointmentType) {
    case 'Montage':
      return {
        documentTitle: 'Abnahme- und Inbetriebnahmeprotokoll',
        fileNameStart: '',
        fileNameEnd: '_AP_gesamt',
      };
    case 'MVT':
      return {
        documentTitle: 'MVT Protokoll',
        fileNameStart: 'MVT PRO_',
        fileNameEnd: '',
      };
    case 'Separater Zählertausch':
      return {
        documentTitle: 'Zählertausch Protokoll',
        fileNameStart: 'Separater_ZT_',
        fileNameEnd: '',
      };
    default:
      return {
        documentTitle: 'Protokoll',
        fileNameStart: 'Protokoll_',
        fileNameEnd: '',
      };
  }
};
